import React from "react";
import GADashboardContainer from "../../modules/GADashboard/containers/GADashboardContainer/GADashboardContainer";
import ReactionsContainer from "../../modules/GAReactions/containers/ReactionsContainer/ReactionsContainer";

const GAReactions = () => {
  //   return <GADashboardContainer />;
  return <ReactionsContainer />;
};

export default GAReactions;
